module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/UnavailableBattle/images/alert-bg.921f5037.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/UnavailableBattle/images/alert-bg.png
// module id = 2526
// module chunks = 11